module.exports = __webpack_public_path__ + "img/remoteService.f16c2e15.svg";